import React from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Link } from "react-router-dom";

const BannerGraphicDesigning = () => {
  return (
    <div className="banner banner-style-1 smm-banner">
      <div className="container">
        <div className="row align-items-end align-items-xl-start">
          <div className="col-lg-6">
            <div className="banner-content">
              <AnimationOnScroll
                animateIn="fadeInUp"
                animateOnce={true}
                delay={100}
              >
                <h1 className="title">Graphic Design & Branding Services</h1>
                <div className="dudhat">
                  <span className="subtitle">
                    At ITCODE InfoTech, we don’t just design — we give your brand a visual soul. Our graphic design and branding services transform ideas into a powerful, consistent identity that resonates with your audience.
                  </span>
                </div>
                <button className="zoom_animation border-0 bg-white">
                  <Link
                    to={process.env.PUBLIC_URL + "/contact"}
                    className="axil-btn btn-fill-primary btn-large"
                  >
                    Contact Us
                  </Link>
                </button>
              </AnimationOnScroll>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="banner-thumbnail">
              <AnimationOnScroll
                animateIn="slideInRight"
                duration={2}
                delay={300}
                animateOnce={true}
                style={{ backgroundColor: '', padding: '20px', marginBottom: "-250px" }}
                className="smm-hero"
              >
                <div className="large-thumb-2">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/banner/GD-hero.webp"
                    }
                    alt="Laptop"
                    height="fit-content"
                  />
                </div>
              </AnimationOnScroll>
            </div>
          </div>

          <ul className="list-unstyled shape-group-21">
            <li className="shape shape-1 blue-shape">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-39.png"}
                alt="Bubble"
              />
            </li>
          </ul>
          <ul className="shape-group-11 list-unstyled">
            <li className="shape shape-1 SMM-hero-bg-shape">
              <img
                src={process.env.PUBLIC_URL + "/images/banner/SMM-hero-bg.png"}
                alt="line"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/banner/SMM-bell.png"}
                alt="line"
                style={{
                  maxWidth: "30%",
                  marginBottom: "90px",
                  marginLeft: "60px"
                }}
              />
            </li>
          </ul>
        </div>
      </div>
      <style jsx>{`
 .smm-banner {
            padding-top: 150px !important;
        }

        .blue-shape {
         top: -18% !important;
        }

      .banner.banner-style-1 .banner-thumbnail .large-thumb-2 {
      top: -100px;
      }

      .SMM-hero-bg-shape img{
        max-width: 60%;
        float: inline-end;
        margin-top: -50px;
      }

    @media (max-width: 1199px) {
        .smm-banner {
            padding-top: 65px !important;
        }

        .smm-hero {
        margin: 0px !important;
        }

        .large-thumb-2 { 
            top: 0px;
        }
    }

    @media (max-width: 991px) {
    .blue-shape {
         top: -8% !important;
         left: -5% !important;
        }

        .banner.banner-style-1 .banner-thumbnail .large-thumb-2 {
        top: 235px !important;
        display:flex;
        }

        .smm-banner {
         padding-bottom: 160px !important;
        }

        .SMM-hero-bg-shape img{
        display: none;
      }
        }
        
     @media (max-width: 767px) {
         .banner.banner-style-1 .banner-thumbnail .large-thumb-2 {
          top: 0 !important;
          }

          .smm-banner {
           padding-bottom: 0px !important;
          }
          }
`}</style>

    </div>
  );
};

export default BannerGraphicDesigning;
